import {createRouter, createWebHistory} from 'vue-router'
import LandingPage from '../views/LandingPage.vue'
import ErrorPage from "@/views/ErrorPage.vue";
import ThankYouPage from "@/views/ThankYouPage.vue";
import TermsAndConditions from "@/views/TermsAndConditions.vue";
import SubmitOtp from "@/views/SubmitOtp.vue";

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: LandingPage
  },
  {
    path: '/submit-otp',
    name: 'SubmitOtp',
    component: SubmitOtp
  },
  {
    path: '/error',
    name: 'Error',
    component: ErrorPage
  },
  {
    path: '/thank-you',
    name: 'ThankYou',
    component: ThankYouPage
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
